import type { FC, ReactNode } from 'react'

import { CommandEmpty, CommandGroup, CommandItem, CommandList } from '@/components/ui/command'

import type { PromptTemplate } from './prompt-template.interface'

export interface PromptTemplateCommandContentProps {
  templateList: PromptTemplate[]
  onSelect: (templateId: string) => void
}

/**
 * Command list content displaying searchable prompt templates.
 */
export const PromptTemplateCommandContent: FC<PromptTemplateCommandContentProps> = ({
  templateList,
  onSelect,
}): ReactNode => (
  <CommandList className="chat-input-templates-list">
    <CommandEmpty>No templates found.</CommandEmpty>
    <CommandGroup heading="Templates">
      {templateList.map((template) => (
        <CommandItem
          key={template.id}
          value={template.id}
          onSelect={onSelect}
          className="chat-input-templates-item"
        >
          <div className="flex flex-col gap-0.5">
            <span className="font-medium">{template.name}</span>
            <span className="line-clamp-1 text-xs text-muted-foreground">
              {template.description}
            </span>
          </div>
        </CommandItem>
      ))}
    </CommandGroup>
  </CommandList>
)

PromptTemplateCommandContent.displayName = 'PromptTemplateCommandContent'
